export interface FilterOption {
  label: string;
  value: string;
}

export interface ComponentChange {
  componentId: string;
  componentType: string;
  componentName: string;
  componentDisplayName?: string;
  // Raw user IDs from API – resolved to names via appmetaInfo
  updatedUserId: string;
  appId?: string;
  applicationName?: string;
  creatorId: string;
  deleteUserId: string;
  renamedUserId: string;
  updated: { author: string; timestamp: string };
  created: { author: string; timestamp: string };
  renamed?: { author: string; timestamp: string };
  deleted?: { author: string; timestamp: string };
}

export interface ComponentChangeDetail {
  dateTime: string;
  action: string;
  author: string;
  fieldName?: string;
  oldValue?: string;
  newValue?: string;
  mergeLog?: boolean;
}

export interface ViewChangesFilters {
  componentType?: string[];
  dateFrom?: string;
  dateTo?: string;
  appIdFilter?: string[];
}

export interface GetComponentChangesParams {
  branchId: string;
  filters: ViewChangesFilters;
  suiteMode?: boolean;
  sort?: { field: string; direction: string };
  page: number;
  length: number;
}

export interface ComponentChangesResponse {
  results: ComponentChange[];
  page: number;
  pageSize: number;
  total: number;
  filtered: number;
}

export interface FilterOptionsResponse {
  data: string[];
}

export interface ComponentChangeDetailsResponse {
  data: ComponentChangeDetail[];
  total: number;
}

export const DEFAULT_VIEW_CHANGES_FILTERS: ViewChangesFilters = {};
export const DEFAULT_PAGE_SIZE = 20;
